export const SET_IS_AUTH = 'AUTH/SET_IS_AUTH';

export const setIsAuth = (is_auth) => ({
  type: SET_IS_AUTH,
  is_auth,
});

export default function reducer(
  state = {
    is_auth: 0,
  },
  action
) {
  switch (action.type) {
    case SET_IS_AUTH:
      return {
        ...state,
        is_auth: action.is_auth,
      };

    default:
  }
  return state;
}
